import styled from '@emotion/styled';
import { StepProps } from './types';
import { theme as defaultTheme } from '../../styles/theme';

export const SytledStep = styled('button')<StepProps>`
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${props =>
    props.active ? defaultTheme.color.text.B6 : defaultTheme.color.text.B3};
  background-color: transparent;
  min-width: 56px;
  padding: 16px 0;
  border: none;
  font-size: ${defaultTheme.typography.fontSize.span}px;
  font-weight: ${props =>
    props.active
      ? defaultTheme.typography.fontWeight.medium
      : defaultTheme.typography.fontWeight.normal};
  line-height: 22px;
  outline: none;

  &:hover {
    color: ${props =>
      props.active ? defaultTheme.color.text.B6 : defaultTheme.color.text.B4};
  }
`;
